<template>
  <div class="home-guide-wraper">
    <!-- 版本公告弹窗 -->
    <div v-if="bootSteps === 1">
      <gj-modal
        :visible="true"
        :destroyOnClose="true"
        type="info"
        size="auto"
        :footer="false"
        no-padding
        :contentStyle="{ height: '100%' }"
      >
        <div slot="content" :style="{ height: '100%' }">
          <img :src="imageUrlImg" class="home-guide-notice-img" />
          <img :src="imageUrlBtn" class="home-guide-notice-btn" @click="nextStep" />
        </div>
      </gj-modal>
    </div>
    <!-- 引导弹窗 -->
    <div v-for="item in data" :key="item.id">
      <div v-if="bootSteps === item.id" class="home-guide" :class="item.class">
        <div class="home-guide-mask"></div>
        <div class="home-guide-content">
          <h4>{{ item.title }}</h4>
          <p>{{ item.text }}</p>
          <ul>
            <li v-for="(ite, index) in item.list" :key="index">{{ ite }}</li>
          </ul>
          <gj-button type="minor" class="home-guide-btn" @click="nextStep">
            {{
              item.btnText
            }}
          </gj-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { modalMixIn } from "@/minxins";
import { saveOrUpdate } from "@/api/message";
export default {
  name: "home-guide",
  mixins: [modalMixIn],
  data() {
    return {
      bootSteps: 0, //步数
      imageUrlBtn: require("@/assets/images/guide-btn.png"),
      imageUrlImg: require("@/assets/images/guide-img.png"),
      imageUrlClose: require("@/assets/images/guide-close.png"),
      returnData: {},
      data: [
        {
          id: 2,
          class: "home-guide-first",
          title: "宝，菜单项全新改版啦！",
          text: "以运营视角进行功能菜单整理，提高亚马逊业务的展示优先级，便于第一时间就能找到自己想要的功能！",
          list: [
            "① 整合产品、销售、分析、广告主要运营模块；",
            "② 将FBA模块单独展示，从补货开始；",
            "③ 将亚马逊报表独立展示，更清晰；",
          ],
          btnText: "下一步",
        },
        {
          id: 3,
          class: "home-guide-two",
          title:
            "宝，店铺授权、广告授权、邮箱授权、充值提醒，出现异常再也不怕不知道了！",
          text: "数据出现异常，发现没有同步，也不知道是啥原因，现在登录系统第一时间就能知道了哦！",
          btnText: "下一步",
        },
        {
          id: 4,
          class: "home-guide-three",
          title: "宝，看板即时的和全店铺的都给你放一起了哦，还新增了其他的时区！",
          list: [
            "① 时区要选择了才会生效哦，不选择时区默认按各站点的市场时间计算，选择则按照时区时间进行数据计算显示；",
            "② 这里还藏了一个小惊喜，等节假日哦；",
            "③ 支持币种切换哦；",
          ],
          btnText: "下一步",
        },
        {
          id: 5,
          class: "home-guide-four",
          title: "宝，今日看板除了销售看板，现在还有库存看板和结算看板哦！",
          list: [
            "① 销售看板默认使用市场时间数据进行统计，再也不用担心数据和销售订单对不上了；",
            "② 手动切换时区，下次咱就记住了，系统默认会用你选择的时区时间进行数据展示哦；",
            "③ 销售额、销量等字段，我们这次把已付款的和未付款的区分开了，鼠标放上去就能看到哦；",
          ],
          btnText: "下一步",
        },
        {
          id: 6,
          class: "home-guide-five",
          title: "宝，广告即时看板也是今日的数据哦！",
          list: [
            "① 即时查看广告的投入产出情况，一眼掌握；",
            "② 进行中的活动和关键词两个维度去查看top50的转化排名，与昨天数据进行对比；",
            "③ 广告数据统计时间也是默认用市场时间统计哦，不想使用市场时间就切换时区统一控制展示的数据吧；",
          ],
          btnText: "下一步",
        },
        {
          id: 7,
          class: "home-guide-six",
          title: "宝，这是属于你的工作台哦！",
          list: [
            "① 即时查看新增的订单数、review数；",
            "② 发货单可以看到有几批货正在头程物流中；",
            "③ FBA货件可以看到亚马逊正在接收的货件数量；",
            "④ 需要回复的买家消息也不担心会漏掉了，没有邮箱授权的话就快去授权吧；",
          ],
          btnText: "下一步",
        },
        {
          id: 8,
          class: "home-guide-seven",
          title: "宝，看完即时数据别忘记看趋势哦~对比过去数据也是很重要的！",
          list: [
            "① 不想看也没关系，右上角有折叠按钮，可以把这个面板收起来哦；",
            "② 可以根据店铺国家分别看历史趋势数据啦；",
          ],
          btnText: "下一步",
        },
        {
          id: 9,
          class: "home-guide-eight",
          title: "宝，这个商品销售看板是一定不能错过的！",
          list: [
            "① 商品即时销售看板，可以自定义展示列的字段哦，不过别选太多了，怕太长了看得不是很舒服呢；",
            "② 可以通过这个面板，选择商品，选择操作按钮，就能进行相应操作哦，快速修改、创建；",
          ],
          btnText: "下一步",
        },
        {
          id: 10,
          class: "home-guide-nine",
          title: "希望老板们喜欢这里！",
          list: [
            "① 按月展示榜单数据，快速了解产品销售数据和人员业绩数据；",
            "② 新增广告推荐，以后会放系统功能使用教程，新功能使用视频等哦，敬请期待；",
          ],
          btnText: "下一步",
        },
        {
          id: 11,
          class: "home-guide-ten",
          title:
            "宝，我们优化了店铺的解绑流程和邮箱授权的绑定流程，比以前好用哦！",
          list: [
            "① 邮箱授权根据邮箱后缀自动填写部分数据字段，明明白白授权，清清楚楚看数据，快体验吧；",
            "② 店铺支持手动删除，不过这样系统就看不到店铺数据了，谨慎操作；",
            "③ 新增了店铺授权日志，谁操作了啥立马就能知道；",
          ],
          btnText: "完成",
        },
      ],
    };
  },
  methods: {
    openNotice(Data) {
      //判断页面，打开更新公告
      if (window.location.href.indexOf("dashboard") > -1) {
        this.bootSteps = 1;
        this.returnData = Data;
      }
    },
    nextStep() {
      // document.querySelector(".workbench").parentNode.offsetTop
      //下一步
      this.bootSteps++;
      if (this.bootSteps === 8) {
        document.querySelector(".content-wrapper").scrollTop = 580; //模块滚动位置
      } else if (this.bootSteps === 9) {
        document.querySelector(".content-wrapper").scrollTop = 1040;
      } else if (this.bootSteps === 10) {
        document.querySelector(".content-wrapper").scrollTop = 1640;
      } else if (this.bootSteps === 11) {
        // 打开店铺授权页
        this.$router.push({
          path: "/system/market",
          query: {
            timeStamp: new Date().getTime()
          }
        });
      } else if (this.bootSteps > 11) {
        this.cancel();
      }
    },
    cancel() {
      //关闭引导
      this.bootSteps = 0;
      this.$emit("homeGuideCancel", 'show');
      this.saveOrUpdate();
    },
    saveOrUpdate() {
      //接口取消步骤引导
      saveOrUpdate(this.returnData)
    },
  },
  // created() {
  //   this.openNotice(1);
  // },
};
</script>

<style scoped lang="scss">
.home-guide {
  position: absolute;
  left: 0;
  top: 0;
  z-index: 2000;
  width: 100%;
  height: 100%;
  min-width: 1366px;
  max-width: 1920px;
  .home-guide-btn {
    background-color: #edf7ff;
    color: #1f6eef;
    border-color: #c4e3ff;
    &:hover {
      color: #1f6eef;
      background: #c4e3ff;
      border-color: #1f6eef;
    }
  }
}

.home-guide-content {
  font-family: PingFang SC;
  font-style: normal;
  padding: 0px 20px;
  background: #ffffff;
  border: 1px solid #1f6eef;
  box-sizing: border-box;
  border-radius: 10px;
  padding-bottom: 15px;
  h4 {
    color: #1f6eef;
    font-weight: 500;
    font-size: 16px;
    line-height: 26px;
    margin: 15px 0;
  }
  p {
    font-weight: normal;
    font-size: 12px;
    line-height: 18px;
    color: #666666;
  }
  ul {
    padding: 0;
    margin: 0;
  }
  li {
    list-style: none;
    font-weight: normal;
    font-size: 12px;
    line-height: 18px;
    color: #666666;
    padding: 8px 0;
  }
}
.home-guide-first {
  .home-guide-btn {
    position: absolute;
    bottom: -45px;
    left: 50%;
    transform: translateX(-50%);
  }
  .home-guide-mask {
    position: absolute;
    left: 0;
    top: 0;
    z-index: 1000;
    width: 100%;
    height: 40px;
    box-shadow: rgba(0, 0, 0, 0.39) 0px 0px 0px 2005px;
  }
  .home-guide-content {
    position: absolute;
    z-index: 1001;
    width: 321px;
    left: 106px;
    top: 51px;
  }
}

.home-guide-two {
  .home-guide-btn {
    position: absolute;
    bottom: -45px;
    left: 50%;
    transform: translateX(-50%);
  }
  .home-guide-mask {
    position: absolute;
    left: 0;
    top: 81px;
    z-index: 1000;
    width: 100%;
    height: 28px;
    box-shadow: rgba(0, 0, 0, 0.39) 0px 0px 0px 2005px;
  }
  .home-guide-content {
    position: absolute;
    z-index: 1001;
    width: 374px;
    left: 169px;
    top: 120px;
  }
}

.home-guide-three {
  .home-guide-btn {
    position: absolute;
    bottom: -45px;
    left: 50%;
    transform: translateX(-50%);
  }
  .home-guide-mask {
    position: absolute;
    left: 0;
    top: 110px;
    z-index: 1000;
    width: 100%;
    height: 54px;
    box-shadow: rgba(0, 0, 0, 0.39) 0px 0px 0px 2005px;
  }
  .home-guide-content {
    position: absolute;
    z-index: 1001;
    width: 604px;
    left: 14px;
    top: 175px;
  }
}

.home-guide-four {
  .home-guide-btn {
    position: absolute;
    bottom: -45px;
    left: 50%;
    transform: translateX(-50%);
  }
  .home-guide-mask {
    position: absolute;
    left: 15px;
    top: 157px;
    z-index: 1000;
    width: calc(67% - 30px);
    height: 328px;
    box-shadow: rgba(0, 0, 0, 0.39) 0px 0px 0px 2005px;
  }
  .home-guide-content {
    position: absolute;
    z-index: 1001;
    width: 610px;
    left: 15px;
    top: 495px;
  }
}

.home-guide-five {
  .home-guide-btn {
    position: absolute;
    bottom: -45px;
    left: 50%;
    transform: translateX(-50%);
  }
  .home-guide-mask {
    position: absolute;
    right: 20px;
    top: 157px;
    z-index: 1000;
    width: calc(34.5% - 28px);
    height: 575px;
    box-shadow: rgba(0, 0, 0, 0.39) 0px 0px 0px 2005px;
  }
  .home-guide-content {
    position: absolute;
    z-index: 1001;
    width: 610px;
    right: 35%;
    top: 156px;
  }
}

.home-guide-six {
  .home-guide-btn {
    position: absolute;
    bottom: 0;
    right: -80px;
  }
  .home-guide-mask {
    position: absolute;
    left: 15px;
    top: 488px;
    z-index: 1000;
    width: calc(67% - 30px);
    height: 245px;
    box-shadow: rgba(0, 0, 0, 0.39) 0px 0px 0px 2005px;
  }
  .home-guide-content {
    position: absolute;
    z-index: 1001;
    width: 395px;
    top: 268px;
    left: calc(35% - 200px);
  }
}

.home-guide-seven {
  .home-guide-btn {
    position: absolute;
    bottom: -45px;
    left: 50%;
    transform: translateX(-50%);
  }
  .home-guide-mask {
    position: absolute;
    left: 15px;
    top: 160px;
    z-index: 1000;
    width: calc(100% - 40px);
    height: 480px;
    box-shadow: rgba(0, 0, 0, 0.39) 0px 0px 0px 2005px;
  }
  .home-guide-content {
    position: absolute;
    z-index: 1001;
    width: 466px;
    top: 650px;
    left: calc(50% - 230px);
  }
}

.home-guide-eight {
  .home-guide-btn {
    position: absolute;
    bottom: -45px;
    left: 50%;
    transform: translateX(-50%);
  }
  .home-guide-mask {
    position: absolute;
    left: 15px;
    top: 180px;
    z-index: 1000;
    width: calc(100% - 40px);
    height: 590px;
    box-shadow: rgba(0, 0, 0, 0.39) 0px 0px 0px 2005px;
  }
  .home-guide-content {
    position: absolute;
    z-index: 1001;
    width: 580px;
    top: 400px;
    left: calc(50% - 280px);
  }
}

.home-guide-nine {
  .home-guide-btn {
    position: absolute;
    bottom: -45px;
    left: 50%;
    transform: translateX(-50%);
  }
  .home-guide-mask {
    position: absolute;
    left: 15px;
    bottom: 30px;
    z-index: 1000;
    width: calc(100% - 40px);
    height: 630px;
    box-shadow: rgba(0, 0, 0, 0.39) 0px 0px 0px 2005px;
  }
  .home-guide-content {
    position: absolute;
    z-index: 1001;
    width: 580px;
    top: 440px;
    left: calc(30% - 280px);
  }
}

.home-guide-ten {
  .home-guide-btn {
    position: absolute;
    bottom: 0px;
    right: -72px;
  }
  .home-guide-mask {
    position: absolute;
    left: 15px;
    top: 222px;
    z-index: 1000;
    width: calc(100% - 30px);
    height: 680px;
    box-shadow: rgba(0, 0, 0, 0.39) 0px 0px 0px 2005px;
  }
  .home-guide-content {
    position: absolute;
    z-index: 1001;
    width: 580px;
    top: 25px;
    left: calc(50% - 280px);
  }
}

.home-guide-notice-img {
  display: block;
  width: 547px;
  height: 438px;
}
.home-guide-notice-btn {
  width: 216px;
  height: 58px;
  display: block;
  margin: 10px auto 0;
  cursor: pointer;
}
.home-guide-notice-close {
  position: absolute;
  top: 52px;
  right: 13px;
  width: 20px;
  height: 20px;
  cursor: pointer;
}
/deep/ .el-dialog {
  background: transparent;
  box-shadow: none;
}
/deep/ .gj-modal,
/deep/.v-modal {
  margin-top: 0 !important;
}
</style>
